import RestApiModel from "@/api/Model/RestApiModel";

class LIORiskCode extends RestApiModel {
  static getResourceEndpoint() {
    return '/product-lio-risk-codes';
  }
}

export default LIORiskCode;
